import { render } from "./ReserveDialog.vue?vue&type=template&id=53b6f96a"
import script from "./ReserveDialog.vue?vue&type=script&lang=js"
export * from "./ReserveDialog.vue?vue&type=script&lang=js"

import "./ReserveDialog.vue?vue&type=style&index=0&id=53b6f96a&lang=css"
script.render = render

export default script